




















import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { ToastType } from '../utils/constants';

@Component({})
export default class ToastActionComponent extends Vue {

    // @Prop() toastType!: ToastType;
    // @Prop() msgObj!: any;

    // mounted() {
    //     console.log('mounted ToastActionComponent');
    // }

    // goToGame(gameId: string) {
    //     console.log(`[ToastActionComponent] goToGame, gameId: ${gameId}`);
    // }

}

